import { render, staticRenderFns } from "./EditSimpleArticle.vue?vue&type=template&id=4e66e6e0"
import script from "./EditSimpleArticle.vue?vue&type=script&lang=ts"
export * from "./EditSimpleArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports